import { useDispatch } from "react-redux";
import { getApiCallState, useStateSelector } from "../Models";
import { useEffect } from "react";
import { Alert, Button, Form, Modal } from "react-bootstrap";
import React from "react";
import { getStrings } from "../../Shared/Reservation/StringResources";
import { SpinnerSmall } from "../../Shared/Components/Spinner";
import { valideraInterrail } from "./Actions";
import { useForm } from "react-hook-form";

const strings = getStrings().component.searchForm;
const commonStrings = getStrings().component.common;

interface INumberFields {
	numbers: string[];
};

export const ValidateInterrailModal = (props: { show: boolean, onClosed: () => void }) => {
	const dispatch = useDispatch();
	const state = useStateSelector(state => state.search);
	const validationState = getApiCallState().getLoadingState("valideraInterrail");

	const { register, formState, handleSubmit, reset, watch } = useForm<INumberFields>({ mode: "onBlur" });

	const numbers = watch("numbers");

	const isValidating = validationState === "loading"
	const travellerCount = state.passengers!.length;

	useEffect(() => {
		if (state.interrailValidation?.isValid)
			props.onClosed();
	}, [state.interrailValidation?.isValid]);

	useEffect(() => {
		if (validationState === "loaded")
			reset();
	}, [validationState])

	useEffect(() => {
		return () => {
			reset();
		};
	}, []);

	const isFieldInvalid = (index: number) => {
		if (formState.touchedFields?.numbers && formState.touchedFields?.numbers[index] && formState.errors?.numbers && formState.errors?.numbers[index])
			return true;

		//Unikt?
		if (numbers?.length > index)
		{
			const value = numbers[index];
			if (value && numbers.filter(x => x === value).length > 1)
				return true;
		}

		//Fel enligt valideringen
		return state.interrailValidation?.result[index]?.valid === false;
	}

	const submit = (data: INumberFields) => {
		dispatch(valideraInterrail(data.numbers, state.departureDate));
	};

	return <Modal show={props.show} onHide={props.onClosed} centered>
		<Form onSubmit={handleSubmit(submit)}>
			<Modal.Header closeButton>
				<Modal.Title>{strings.interrailModal.title}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<p>{strings.interrailModal.description}</p>

				<Form.Group controlId="formInterrail">
					<Form.Label>{strings.interrailModal.numberLabel}</Form.Label>
					{
						state.passengers!.map((_,idx) => <Form.Control key={idx} type="text" className="mb-1" {...register(`numbers.${idx}`, { required: true })}
								isInvalid={isFieldInvalid(idx)} defaultValue={state.interrailValidation?.result && state.interrailValidation.result[idx]?.number || ""}
								placeholder={strings.interrailModal.numberPlaceholder + (travellerCount > 1 ? ` #${(idx+1)}` : "")} />)
					}
					{ travellerCount > 1 && <Form.Text className="text-muted">{strings.interrailModal.numberDescription}</Form.Text>}

				</Form.Group>

				<Alert variant="danger" show={state.interrailValidation?.isValid === false}>{travellerCount === 1 ? strings.interrailModal.numberInvalid : strings.interrailModal.numbersInvalid}</Alert>
				<Alert variant="danger" show={validationState === "error"}>{strings.interrailModal.validationFailed}</Alert>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" onClick={props.onClosed}>{commonStrings.close}</Button>
				<Button variant="primary" type="submit" disabled={isValidating}>{strings.interrailModal.buttonText} {isValidating && <SpinnerSmall />}</Button>
			</Modal.Footer>
		</Form>
	</Modal>
}